import { Option, pipe } from "fp";

import React from "react";

import { Breadcrumb as GenericBreadcrumb } from "~/Breadcrumb";
import * as Driver from "~/Driver";
import * as Layout from "~/Layout";
import * as GenericLink from "~/Link";
import * as Log from "~/Log";
import { Route as GenericRoute } from "~/Route";
import { Time } from "~/Time";

export function Page() {
  return pipe(
    Driver.useReferenceFromRoute(),
    Option.map((driver) =>
      Driver.useFromReference({
        ...driver,
        missing: () => null,
        found: (driver) => (
          <Layout.Page.Component all>
            <Page.Breadcrumb driver={driver} />
            <Log.Summaries
              baseRoute={Page.Route.href({ driver })}
              driver={driver}
              {...Log.Summaries.Interval.initial(Time.DateTime.now())}
            />
          </Layout.Page.Component>
        ),
      })
    ),
    Option.toNullable
  );
}

export namespace Page {
  export type Route = { readonly driver: Pick<Driver.Driver, "id" | "name"> };
  export namespace Route {
    export const definition = (): string =>
      `${Driver.Overview.Route.definition()}/:readableID`;

    export const href = ({ driver }: Route): string =>
      `${Driver.Overview.Route.definition()}/${Driver.toReadableID(driver)}`;

    export const use = (route: Route) => GenericRoute.use(href(route));
  }

  export const Breadcrumb = ({
    driver,
  }: {
    readonly driver?: Driver.Driver;
  }) => (
    <Layout.Block.Component bottom>
      <GenericBreadcrumb>
        <GenericBreadcrumb.Item>
          <GenericLink.Component onClick={Driver.Overview.Route.use().go}>
            Drivers
          </GenericLink.Component>
        </GenericBreadcrumb.Item>
        <GenericBreadcrumb.Item>
          <Driver.Name.Component {...driver} noLink includeInactive />
        </GenericBreadcrumb.Item>
      </GenericBreadcrumb>
    </Layout.Block.Component>
  );
}
